import React from 'react';

import { Form as AntForm } from 'antd';
import { FormProps } from 'antd/lib/form';
import { FormProvider } from 'antd/lib/form/context';
import useForm from 'antd/lib/form/hooks/useForm';

import { ErrorList } from './ErrorList';
import { FormItem } from './FormItem';
import { FormList } from './FormList';

export interface IFormProps extends FormProps {}

type TForm = React.FC<IFormProps> & {
  ErrorList: typeof ErrorList;
  Item: typeof FormItem;
  List: typeof FormList;
  Provider: typeof FormProvider;
  useForm: typeof useForm;
};

/**
 * Form component
 */
export const Form: TForm = (props) => <AntForm {...props} />;

Form.ErrorList = ErrorList;
Form.Item = FormItem;
Form.List = FormList;
Form.Provider = FormProvider;
Form.useForm = useForm;
